<template>
	<transition
			appear
			:appear-active-class="$_inpRdb_styleInputRadioButtonAnimation()">
		<v-row no-gutters>
			<v-col>
				<v-row no-gutters>
					<v-col>
						<validation-provider
								:name="'InputRadioButton-' + contentKey"
								:rules="getValidationRules(contents[contentKey].rules)"
								v-slot="{ errors }">
							<v-radio-group
									class="radioGroup_"

									v-model="$store.state.input.data[contentKey].answer"

									hide-details

									:background-color="$_inpRdb_styleRadioButtonBackgroundColor"
									:color="$_inpRdb_styleRadioButtonColor"
									:column="$_inpRdb_styleRadioButtonColumn"
									:dark="$_inpRdb_styleRadioButtonDark"
									:light="$_inpRdb_styleRadioButtonLight"
									:row="$_inpRdb_styleRadioButtonRow"

									:append-icon="$_inpRdb_styleParamAppendIcon(contents[contentKey].params)"
									:prepend-icon="$_inpRdb_styleParamPrependIcon(contents[contentKey].params)"

									:error-messages="errors">
								<template v-for="(answerOptionVals, answerOptionKey) in sortObject(contents[contentKey].options, 'order', 'asc')">
									<v-radio 
											class="radio_"
											:key="answerOptionKey"
											:label="$_inpRdb_langAnswerOptionText(answerOptionVals)"
											:value="answerOptionVals" />
								</template>
							</v-radio-group>
						</validation-provider>
					</v-col>
				</v-row>
				<template v-if="$_inpRdb_langParamHint(contents[contentKey].params)">
					<v-row>
						<v-col>
							<span	class="hint_"
									v-text="$_inpRdb_langParamHint(contents[contentKey].params)" />
						</v-col>
					</v-row>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputRadioButton',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpRdb_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpRdb_langAnswerOptionText() {
				const self_ = this;
				return answerOptionVals => {
					const answerOptionVal_ = answerOptionVals.text;
					if(self_.isFalse(answerOptionVal_)) { return null }
					return self_.getLangsVal(answerOptionVal_)
				}
			},
			// style
			$_inpRdb_styleInputRadioButton() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputRadioButton')
				}
			},
			$_inpRdb_styleInputRadioButtonAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpRdb_styleInputRadioButton()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpRdb_styleRadioButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'radioButton')
			},
			$_inpRdb_styleRadioButtonBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpRdb_styleRadioButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpRdb_styleRadioButtonColor() {
				const self_ = this;
				const style_ = self_.$_inpRdb_styleRadioButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpRdb_styleRadioButtonColumn() {
				const self_ = this;
				const style_ = self_.$_inpRdb_styleRadioButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.column)
			},
			$_inpRdb_styleRadioButtonDark() {
				const self_ = this;
				const style_ = self_.$_inpRdb_styleRadioButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpRdb_styleRadioButtonLight() {
				const self_ = this;
				const style_ = self_.$_inpRdb_styleRadioButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpRdb_styleRadioButtonRow() {
				const self_ = this;
				const style_ = self_.$_inpRdb_styleRadioButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.row)
			},
			$_inpRdb_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpRdb_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}
	}
</script>

<style scoped>
	.radioGroup_ {
		margin-top: 0;
	}
	.radio_ {
		margin-top: 20px;
		margin-bottom: 0 !important;
	}
	.hint_ {
		font-size: small;
	}
</style>
